export const SET_CLOUDINARY_CREDS = 'SET_CLOUDINARY_CREDS';